<template>
  <v-card class="mx-auto overflow-visible " width="580px" style="margin-top: 0px; margin-bottom: 0px;z-index: 99" outlined :loading="isLoadData">
    <v-list-item three-line>
      <v-list-item-content class="overflow-visible d-block">
        <v-row class="align-center">
          <v-col cols="10">
            <v-list-item-title class="headline mb-2">Tìm kiếm nâng cao</v-list-item-title>
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon aria-label="Close" @click="closeMenuPopup">mdi-close</v-icon>
          </v-col>
        </v-row>
        <v-divider style=" margin-bottom: 20px;"></v-divider>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col cols="12">
                <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thông tin chăm sóc</div>
                <v-row>
                  <v-col cols="4" class="d-flex align-center pl-6">
                    Quản lý học tập
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                      @change="toggleSelectTeacher()"
                      v-model="filterForm.homeroomTeacherIds"
                      :items="listGVCNDuo"
                      item-text="name"
                      item-value="id"
                      no-data-text="Không có dữ liệu"
                      :placeholder="filterForm.hasNoTeacher ? 'Không có quản lý học tập' : 'Chọn Quản lý học tập'"
                      clearable
                      multiple
                      hide-details
                      persistent-placeholder
                      :search-input.sync="searchInputTeacher"
                      outlined
                      dense
                      chips
                      clear-icon="mdi-trash-can-outline"
                    >
                      <template #selection="{item}">
                        <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.homeroomTeacherIds, item.id)">
                          {{handleCutChipText(item.name)}}
                        </v-chip>
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-item
                          ripple
                          @mousedown.prevent
                          @click="toggleHasNoTeacher"
                        >
                          <v-list-item-action>
                            <v-icon :color="filterForm.headTeacher.length > 0 ? 'indigo darken-4' : ''">
                              {{ filterForm.hasNoTeacher ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>
                              Không có Quản lý học tập
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="d-flex align-center pl-6">
                    Sale gia hạn
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                      @change="toggleSelectSale"
                      v-model="filterForm.userIds"
                      :items="listUser"
                      item-text="fullName"
                      item-value="id"
                      :placeholder="filterForm.hasNoSale ? 'Không có Sale gia hạn' : 'Chọn Sale gia hạn'"
                      no-data-text="Không có dữ liệu"
                      clearable
                      multiple
                      hide-details
                      persistent-placeholder
                      :search-input.sync="searchInputSale"
                      outlined
                      dense
                      chips
                      clear-icon="mdi-trash-can-outline"
                    >
                      <template #selection="{item}">
                        <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.userIds, item.id)">
                          {{handleCutChipText(item.fullName)}}
                        </v-chip>
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-item
                          ripple
                          @mousedown.prevent
                          @click="toggleHasNoSale"
                        >
                          <v-list-item-action>
                            <v-icon>
                              {{ filterForm.hasNoSale ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>
                              Không có Sale gia hạn
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thông tin học sinh</div>
                <v-row>
                  <v-col cols="4" class="d-flex align-center pl-6">
                    Sản phẩm
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                      v-model="filterForm.productIds"
                      :items="productList"
                      item-text="name"
                      item-value="id"
                      placeholder="Chọn sản phẩm"
                      no-data-text="Không có dữ liệu"
                      clearable
                      multiple
                      hide-details
                      persistent-placeholder
                      :search-input.sync="searchInputProduct"
                      @change="searchInputProduct=''"
                      outlined
                      dense
                      chips
                      clear-icon="mdi-trash-can-outline"
                    >
                      <template #selection="{item}">
                        <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.productIds, item.id)">
                          {{handleCutChipText(item.name)}}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thời gian</div>
                <v-row>
                  <v-col cols="4" class="d-flex align-center pl-6">
                    Ngày hết hạn
                  </v-col>
                  <v-col cols="8">
                    <common-range-picker
                      :clearable="true"
                      :aLight="'left'"
                      v-model="filterForm.courseEndDates"
                      class="'show-date"
                      :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                      @show-date-picker="showDate(1)"
                      @input="updateCourseEndDate()"
                      @check-close-on-click="checkCloseOnClick"
                      isFilter
                      noneMargin
                    ></common-range-picker>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="d-flex align-center pl-6">
                    Ngày phân học sinh
                  </v-col>
                  <v-col cols="8">
                    <common-range-picker
                      :clearable="true"
                      :aLight="'left'"
                      v-model="filterForm.distributeDate"
                      class="'show-date"
                      :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                      @show-date-picker="showDate(1)"
                      @check-close-on-click="checkCloseOnClick"
                      isFilter
                      noneMargin
                    ></common-range-picker>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="d-flex align-center pl-6">
                    Ngày tạo đơn
                  </v-col>
                  <v-col cols="8">
                    <common-range-picker
                      :clearable="true"
                      :aLight="'left'"
                      v-model="filterForm.orderCreatedAt"
                      class="'show-date"
                      :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                      @show-date-picker="showDate(1)"
                      @check-close-on-click="checkCloseOnClick"
                      isFilter
                      noneMargin
                    ></common-range-picker>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider style="margin-bottom: 20px;margin-top: 20px;"></v-divider>
        <div class="text-center mb-4 ">
          <v-btn class="primary mx-2" @click="searchDuoStudent" style="background-color: #E91E63 !important">
            Áp dụng bộ lọc
          </v-btn>
<!--          <v-btn-->
<!--            class="primary mx-2"-->
<!--            @click="downloadExcel(filterForm)"-->
<!--          >-->
<!--            <v-icon>mdi-download</v-icon>Download-->
<!--          </v-btn>-->
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>
<script>
import moment from 'moment';
import { mapActions, mapState } from 'vuex';
import RepositoryFactory from '../../../services/RepositoryFactory';

const ProductRepository = RepositoryFactory.get('product');

export default {
  name: 'ContactStatusFilterForm',
  props: ['filterForm', 'listUser'],
  data() {
    return {
      isLoadData: false,
      maxDate: new Date(),
      // minDate: new Date((new Date()).getTime() - 6 * 24 * 60 * 60 * 1000),
      minDate: null,
      typeSearch: [{ value: 'eq', label: 'BẰNG' }, { value: 'lt', label: 'NHỎ HƠN' }, { value: 'gt', label: 'LỚN HƠN' }],
      productList: [],
      subjects: [{ id: 1, name: 'Toán' }, { id: 15, name: 'Ngữ Văn' }, { id: 5, name: 'Tiếng anh' }],
      searchInputProduct: null,
      searchInputSale: null,
      searchInputTeacher: null,
      searchInputStage: null,
      searchDateTest: null,
      currentPicker: null,
      isFirstDateSelected: false,
    };
  },
  created() {
    this.getListGVCNDuo();
    this.getListProduct();
  },
  computed: {
    ...mapState('duo_care', ['listGVCNDuo']),
    ...mapState('student_care', ['listCallStatus']),
    ...mapState('contact_status', ['listStatus']),
    listCallStatusForSelect() {
      const listCallStatus = [];
      this.listStatus.forEach((call) => {
        listCallStatus.push({
          header: call.name,
        });
        listCallStatus.push(...call.data);
      });
      return listCallStatus;
    },
  },
  methods: {
    ...mapActions('duo_care', ['getListGVCNDuo']),
    handleCutChipText(text, number = 20) {
      return text.length > number ? `${text.slice(0, number - 2)}...` : text;
    },
    checkCloseOnClick(val) {
      this.$emit('change-close-on-click', !val);
    },
    removeItem(items, item) {
      const index = items.indexOf(item);
      if (index >= 0) items.splice(index, 1);
    },
    closeMenuPopup() {
      this.filterForm.closeMenu = false;
    },
    updateCourseEndDate() {
      this.filterForm.noEndDate = false;
    },
    async searchDuoStudent() {
      const diffDays = parseInt((new Date(this.filterForm.courseEndDates[0]) - new Date(this.filterForm.courseEndDates[1])) / (1000 * 60 * 60 * 24), 10);
      if (diffDays && Math.abs(diffDays) > 30) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Chỉ tìm kiếm được tối đa trong vòng 30 ngày !!',
        });
      } else {
        if (this.filterForm.orderCreatedAt.length) {
          this.filterForm.orderCreatedAt[0] = moment(this.filterForm.orderCreatedAt[0]).format('YYYY-MM-DD 00:00:00');
          this.filterForm.orderCreatedAt[1] = moment(this.filterForm.orderCreatedAt[1]).format('YYYY-MM-DD 23:59:59');
        }
        Bus.$emit('duo-care-list-filter');
        this.closeMenuPopup();
      }
    },
    changeToNoEndDate() {
      if (this.filterForm.noEndDate) {
        this.filterForm.courseEndDates = [];
      }
    },
    toggleHasNoTeacher() {
      this.$nextTick(() => {
        this.filterForm.hasNoTeacher = !this.filterForm.hasNoTeacher;
        this.filterForm.homeroomTeacherIds = [];
      });
    },
    toggleSelectTeacher() {
      this.searchInputTeacher = '';
      this.$nextTick(() => {
        if (this.filterForm.homeroomTeacherIds.length > 0) {
          this.filterForm.hasNoTeacher = false;
        }
      });
    },
    toggleHasNoSale() {
      this.$nextTick(() => {
        this.filterForm.hasNoSale = !this.filterForm.hasNoSale;
        this.filterForm.userIds = [];
      });
    },
    toggleSelectSale() {
      this.searchInputSale = '';
      this.$nextTick(() => {
        if (this.filterForm.userIds.length > 0) {
          this.filterForm.hasNoSale = false;
        }
      });
    },
    showDate(index) {
      this.currentPicker = index;
    },
    // check bo loc ko duoc de trong
    checkIsEmpty(filterForm) {
      // khoi tao bien check rong
      let isDateTime = true;
      let isType = true;
      let isCaseTypeIds = true;
      let isCreatedAt = true;
      let isCreatedBy = true;
      let isInterviewUser = true;
      let isListInterviews = true;
      let isOperatorOrTesterId = true;
      let isSearchInfo = true;
      let isSelectedShift = true;
      let isStatus = true;
      let isSubjectId = true;

      // chay dieu kien check rong
      if (filterForm.dateTime && filterForm.dateTime.length === 0) isDateTime = false;
      if (filterForm.type == null) isType = false;
      if (filterForm.caseTypeIds && filterForm.caseTypeIds.length === 0) isCaseTypeIds = false;
      if (filterForm.createdAt && filterForm.createdAt.length === 0) isCreatedAt = false;
      if (filterForm.createdBy && filterForm.createdBy.length === 0) isCreatedBy = false;
      if (filterForm.interviewUser && filterForm.interviewUser.length === 0) isInterviewUser = false;
      if (filterForm.listInterviews && filterForm.listInterviews.length === 0) isListInterviews = false;
      if (filterForm.operatorOrTesterId && filterForm.operatorOrTesterId.length === 0) isOperatorOrTesterId = false;
      if (filterForm.searchInfo === '') isSearchInfo = false;
      if (filterForm.selectedShift && filterForm.selectedShift.length === 0) isSelectedShift = false;
      if (filterForm.status === '') isStatus = false;
      if (filterForm.subjectId == null) isSubjectId = false;

      if (isDateTime || isType || isCaseTypeIds || isCreatedAt || isCreatedBy || isInterviewUser
        || isListInterviews || isOperatorOrTesterId || isSearchInfo || isSelectedShift || isStatus || isSubjectId) {
        return true;
      } return false;
    },
    async downloadExcel(filterForm) {
      const check = this.checkIsEmpty(filterForm);
      if (!check) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng chọn ít nhất 1 điều kiện tìm kiếm',
        });
        return;
      }
      Bus.$emit('download-excel-filter', filterForm);
    },
    async getListProduct() {
      const res = await ProductRepository.getList({
        limit: 1000,
      });
      if (res?.success) {
        this.productList = res?.data;
      }
    },
  },
};
</script>
<style lang="css" scoped>
/deep/.hide-date .daterangepicker.dropdown-menu{
  display: none
}
/deep/.show-date .daterangepicker.dropdown-menu{
  display: block;
}
/deep/.v-subheader.theme--light {
    background: #ddd;
}
</style>
